"use client";

import { useRequireGuest } from "@/hooks";

/**
 * GuestOnlyPage Props
 *
 * Guest-only gate around a page, with an optional post-login redirect.
 */
interface GuestOnlyPageProps {
  children: React.ReactNode;
  redirectTo?: string;
  autoRedirect?: boolean;
  redirectDelay?: number;
  loadingComponent?: React.ReactNode;
  redirectingComponent?: React.ReactNode;
  checkEmailVerification?: boolean;
  showRedirectMessage?: boolean;
}

/**
 * GuestOnlyPage Component
 *
 * Route gate that renders children only for signed-out visitors.
 *
 * @returns Children, or null while a signed-in user is redirected
 */
const GuestOnlyPage = ({ children, redirectTo = "/" }: GuestOnlyPageProps) => {
  // Sends signed-in users away so this page stays guest-only
  const { isGuest } = useRequireGuest({
    redirectTo,
  });

  if (!isGuest) return null;

  return <>{children}</>;
};

export { GuestOnlyPage };
